import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Sparkles } from 'lucide-react'

import { LoginRequiredState } from '@/features/auth/components/LoginRequiredState'
import { StudioFeatureGuard } from '@/features/studio/components/StudioFeatureGuard'
import { CatalogListPageShell } from '@/shared/components/catalog/CatalogListPageShell'
import { PageHeading } from '@/shared/components/PageHeading'
import { useAuth } from '@/hooks'

function isGuestStudioPath(pathname: string): boolean {
  return pathname.startsWith('/studio/invites/')
}

/** 创作中心域壳：登录校验 + 子模块 feature 守卫（未登录 UI 与个人中心等页对齐） */
export function StudioShellLayout() {
  const { pathname, search } = useLocation()
  const { t } = useTranslation()
  const { isAuthenticated } = useAuth()
  const guestOk = isGuestStudioPath(pathname)

  if (!guestOk && !isAuthenticated) {
    const redirectTo = `${pathname}${search}`
    return (
      <CatalogListPageShell>
        <PageHeading icon={Sparkles} tone="indigo" prefixed title={t('studio.title')} />
        <LoginRequiredState
          contained={false}
          className="mt-2"
          redirectTo={redirectTo}
          icon={Sparkles}
          tone="indigo"
          title={t('studio.loginRequired')}
          subtitle={t('studio.loginRequiredHint')}
        />
      </CatalogListPageShell>
    )
  }

  return (
    <StudioFeatureGuard>
      <Outlet />
    </StudioFeatureGuard>
  )
}
